// base url
export const BASE_URL = "https://api.azzirevents.com/";
// export const BASE_URL = "http://localhost:3000/";

// api endpoints
export const SIGN_UP = "api/register";
export const SIGN_IN = "user";
export const PROFILE = "api/user";

export const OTP = "users/";
export const FORGEPASSWORD = "users/";
export const RESETPASSWORD = "users/";
export const LIST = "users/";
export const LOGOUT = "users/";

export const ARTIST = "clubs";
export const CLUBLOCATION = "";
export const SPOTLIGHT = "";
export const UPCOMINGEVENT = "";

export const UXACTIVITY = "ux-activity";

export const REPORT_CLUB_CLOSURE = "api/report-club-closure";
export const HOUSE_PARTIES = "api/house-parties";

export const BLOGS = "api/blogs";
export const BLOGS_HOME = "api/blogs/home";
export const BLOGS_SEARCH = "api/blogs/search";
export const REFERRALS_VALIDATE = "api/referrals/validate";
export const REFERRALS_CLICK = "api/referrals/click";
